var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderlineCounselorInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 6,
    viewBox: "0 0 87 6",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5672 2.58666C27.6016 2.58666 37.6387 2.20021 47.7031 2.1548C55.4928 2.11966 63.2457 2.02132 71.0427 2.02132C72.0701 2.02132 79.7976 1.919 75.3194 2.16266C63.2614 2.81872 51.537 3.576 39.0502 3.576C29.7503 3.576 20.5965 3.62316 11.3345 3.72518C8.68841 3.75433 5.9146 3.80408 3.27834 3.86652C0.851785 3.92399 2.39021 3.86982 3.70933 3.85867C11.9411 3.78904 20.3481 3.80657 28.5739 3.86652C34.5777 3.91027 40.5264 4 46.5427 4C55.1645 4 63.7091 3.71733 72.3356 3.71733C76.6371 3.71733 80.7572 3.576 85 3.576",
    stroke: "#ECFAF9",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineCounselorInfo);
export default __webpack_public_path__ + "static/media/underline-counselor-info.e1db5148aa5b3346c39f53703a548829.svg";
export { ForwardRef as ReactComponent };